import {map} from 'lodash'
import React from "react"
import SelectField from "components/redesign/SelectField"

const SimpleDropdown = ({DropDownItems, onAnswered, value, disabled = false}) => (
  <SelectField
    options={map(DropDownItems, item => ({key: item, label: item}))}
    value={value}
    onChange={onAnswered}
    disabled={disabled}
  />
);

export default SimpleDropdown;
